import React from "react";

import { Button } from '../../../../helpers';
import "../../index.css"


const ValidateCategoryModal = (props) => {
    const { handleMaterialSaveClick, predictedCategory, materialDetails, materialCategories, selectedCategory, setIsCategoryValidationVisible} = props;

    const predictCategory = (category) => {
        if(category === predictedCategory){
            const relatedPredictedCategory = materialCategories.find(each => each.categoryName === category)
            let updatedMaterialDetail = {...materialDetails}
            if (relatedPredictedCategory){
                updatedMaterialDetail = {...updatedMaterialDetail, categoryId: relatedPredictedCategory.categoryId}
            }
            handleMaterialSaveClick(updatedMaterialDetail)
        }else{
            handleMaterialSaveClick(materialDetails)
        }
    }

    return (
        <div className="predict-category">
            <div className="gif-container" >
                <img 
                    className="gif"
                    src="https://i.giphy.com/media/v1.Y2lkPTc5MGI3NjExM3pnaG10Znc3aWVkcm9lcGt3eXFzbGxtcWY5MzdpYnpmanh6NndjeSZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/5k5vZwRFZR5aZeniqb/giphy.gif" 
                    alt="Jaadu AI"
                    
                />
                <p className="jaadu-text">Hey, I'm Jaadu</p>
            </div>
            <div className="jaadu-intro">
                <p>
                    I think the right category for this material is <b> "{predictedCategory}".</b> <br />
                    You have assigned <b> "{selectedCategory}".</b><br />
                </p>
            </div>
            <h5>Which category do you want to assign?</h5>
            <div>
                <Button 
                    className="category-button" 
                    label={predictedCategory} 
                    onClick={() => predictCategory(predictedCategory)} 
                />
                <Button 
                    className="category-button"
                    label={selectedCategory} 
                    onClick={() => predictCategory(selectedCategory)}
                />
            </div>
        </div>
    )
}

export default ValidateCategoryModal;